<template>
  <footer>
    <div class="footer-wrapper">
      <div class="footer-area footer-padding">
        <div class="container">
          <div class="row justify-content-between">
            <!-- logo -->
            <div class="col-lg-3 col-md-6 col-sm-8">
              <div class="single-footer-caption mb-50">
                <div class="single-footer-caption mb-20">
                  <!-- logo -->
                  <div class="footer-logo mb-35">
                    <router-link to="/"><img :src="$imagens + 'logo.png'" alt=""></router-link>
                  </div>
                  <div class="footer-tittle" v-if="topoMenu!=''">
                    <div class="footer-pera">
                      <p v-html="topoMenu[0].itiResumo1"></p>
                    </div>
                  </div>
                  <!-- social -->
                  <div v-if="redesSociais != ''">
                    <ul class="footer-social icone-social">
                       <li><a v-if="redesSociais[0].itiNome != 0 && redesSociais[0].itiNome != null"
                            :href="redesSociais[0].itiNome" target="_blank"><i class="fab fa-facebook"></i></a>
                        </li>
                        <li><a v-if="redesSociais[0].itiReferencia != 0 && redesSociais[0].itiReferencia != null"
                            :href="redesSociais[0].itiReferencia" target="_blank"><i class="fab fa-instagram"></i></a>
                        </li>
                        <li><a v-if="redesSociais[0].itiCampoExtra2 != 0 && redesSociais[0].itiCampoExtra2 != null"
                            :href="redesSociais[0].itiCampoExtra2" target="_blank"><i
                              class="fab fa-linkedin-in"></i></a></li>
                        <li><a v-if="redesSociais[0].itiCampoExtra1 != 0 && redesSociais[0].itiCampoExtra1 != null"
                            :href="redesSociais[0].itiCampoExtra1" target="_blank"><i class="fab fa-youtube"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <!-- menu -->
            <div class="col-lg-2 col-md-4 col-sm-6">
              <div class="single-footer-caption mb-50">
                <div class="footer-tittle">
                  <h4>Menu</h4>
                  <ul>
                    <li><router-link to="/">Home</router-link></li>
                    <li><router-link to="/sobre">Sobre</router-link></li>
                    <li v-show="false"><router-link to="/blog">Igor News</router-link></li>
                     <li v-show="false"><router-link to="/representantes">Representantes</router-link></li>
                    <li><router-link to="/contato">Contato</router-link></li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- produtos -->
            <div class="col-lg-3 col-md-4 col-sm-6">
              <div class="single-footer-caption mb-50">
                <div class="footer-tittle">
                  <h4>Produtos</h4>
                  <ul v-if="segmentospais != '' && segmentospais.length > 0">
                    <li v-for="menuProduto in segmentospais" :key="menuProduto.sgiId">
                      <router-link
                        :to="'/Produto/' + menuProduto.sgiId + '/' + formataLink(menuProduto.sgiNomeSegmento)">
                        {{ menuProduto.sgiNomeSegmento }}
                      </router-link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- informações gerais -->
            <div class="col-lg-3 col-md-6 col-sm-8">
              <div class="single-footer-caption mb-50">
                <div class="footer-tittle mb-10">
                  <h4>Informações Gerais</h4>
                  <ul>
                    <li v-for="lgpd in informacoes" :key="lgpd.itiId">
                      <router-link
                        :to="'/informacoes/' + lgpd.itiId + '/' + lgpd.itiNome.replaceAll(' ', '-').replaceAll(',', '')">
                        {{ lgpd.itiNome }}
                      </router-link>
                    </li>
                  </ul>
                </div>
                <!-- Form -->
                <div class="footer-form mb-20">
                  <div id="mc_embed_signup">

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- footer-bottom area -->
      <div class="footer-bottom-area">
        <div class="container">
          <div class="footer-border">
            <div class="row">
              <div class="col-xl-12 ">
                <div class="footer-copy-right text-center">
                  <p><a href="https://avancedigital.com.br" target="_blank">Avance Digital</a></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>

   <div v-if="LinkWhats != ''" class="whatsapp-fixo">
      <a :href="LinkWhats[0].itiLinkBtn1" target="_blank">
        <img src="/images/atendimentoWhatsapp.png" alt="Fale Conosco pelo WhatsApp" />
      </a>
    </div>

  <!--div id="back-top">
    <a title="Go to Top" href="#"> <i class="fas fa-level-up-alt"></i></a>
  </!--div-->

</template>

<script>
import axios from 'axios';

export default {
  name: 'PageFooter',
  components: {

  },
  data: () => ({
    redesSociais: [],
    informacoes: [],
    segmentospais: [],
    topoMenu:[],
    LinkWhats: [],
  }),
  methods: {
    formataLink(value) {
      return value.replaceAll('/', '').replaceAll(' ', '-').replaceAll('.', '').replaceAll('+', '');
    },
  },
  async created() {

        axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.LinkWhats = response.data;
        //console.log('topo menu')
        //console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

    // redes sociais 
    axios.get('/Process/InsInstitucional/institucional/20/redessociais/0/x')
      .then(response => {
        this.redesSociais = response.data;
        //console.log('redesSociais')
        //console.log(this.redesSociais)
      })
      .catch(error => {
        console.error(error);
      });

     // lista segmentos
      const segmentosRes = await axios.get('/Process/InsSegmentos/GetAll');
			this.segmentospais = segmentosRes.data
				.filter(x => x.sgiIdPai == 0 && x.sgiVisivel)
				.sort((a, b) => a.sgiNomeSegmento.localeCompare(b.sgiNomeSegmento));

       // console.log('segmentospais')
       // console.log(this.segmentospais)

    // informações gerais
    axios.get('/Process/InsInstitucional/institucional/18/informacoes/0/x')
      .then(response => {
        this.informacoes = response.data.filter(x => x.itiVisivel).sort((a, b) => a.itiOrdem - b.itiOrdem);
        //console.log('informacoes')
        //console.log(this.informacoes)
      })
      .catch(error => {
        console.error(error);
      });

       // dados topo 
    axios.get('/Process/InsInstitucional/institucional/9/cabecalho/0/x')
      .then(response => {
        this.topoMenu = response.data;
       console.log('topo menu')
       console.log(this.topoMenu)
      })
      .catch(error => {
        console.error(error);
      });

  },
}
</script>

<style>
/* WHATSAPP FIXO */
.whatsapp-fixo {
  position: fixed;
  bottom: 25px;
  right: 10px;
  z-index: 999;
}

</style>